import { createContext } from 'react'

export const ToneContext = createContext({})
